/**
 * Google Tag Manager container for WellPath Fusion.
 * Tags, triggers and variables are managed in the GTM dashboard, not here.
 */
export const GTM_ID = 'GTM-WR78XKCX'

/** localStorage key holding the visitor's cookie choice ('granted' | 'denied'). */
export const CONSENT_STORAGE_KEY = 'wpf-cookie-consent'

/** Fired on window to reopen the banner after a choice has been made. */
export const CONSENT_REOPEN_EVENT = 'wpf:open-cookie-consent'

/**
 * Consent Mode v2 signals we toggle together. `security_storage` is excluded
 * because it is strictly necessary and stays granted at all times.
 */
export const CONSENT_SIGNALS = [
    'ad_storage',
    'ad_user_data',
    'ad_personalization',
    'analytics_storage',
    'functionality_storage',
    'personalization_storage'
] as const
